import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  buttonsGroup: {
    '&&': {
      marginBottom: SPACES.m,

      color: theme.palette.custom.grey2,

      [theme.breakpoints.down('tablet')]: {
        '& button': {
          paddingLeft: 2,
          paddingRight: 2,
          fontSize: FONTS.SIZES.xs,
        },
      },
    },
  },
}))
